import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { STICKY_HEADER_HEIGHT } from '@/core/constants/layout';

import { Section } from '../dcrNavigation/dcrNavigation.types';
import { filteredArr } from '../dcrNavigation/dcrNavigationStore';

import { type ProfileNavigationState } from './profileNavigation.types';

export const useProfileNavigationStore = create<ProfileNavigationState>()(
	devtools(set => ({
		sections: [],
		stickyHeaderHeight: STICKY_HEADER_HEIGHT,

		addSection: (section: Section) =>
			set(({ sections }) => ({
				sections: filteredArr([...sections, section])
			})),
		removeSection: (id: Section['id']) =>
			set(({ sections }) => ({
				sections: sections.filter(s => s.id !== id)
			})),
		setStickyHeaderHeight: (stickyHeaderHeight: number) =>
			set({ stickyHeaderHeight })
	}))
);
